import { Icon } from '@iconify/react'
import { Reactive, reactive, Show, useObservable } from '@legendapp/state/react'
import { AnimatePresence } from 'framer-motion'
import { FC, ReactNode, useCallback } from 'react'

import { ConsoleLayout, Tooltip, TooltipContent, TooltipTrigger } from '~in-app/components'
import { cn } from '~in-app/lib/utils'

interface MenuSectionProps {
  sectionLabel: ReactNode | string
}

const ReactiveTooltip = reactive(Tooltip)

const MenuSection: FC<MenuSectionProps> = ({ sectionLabel }) => {
  const layoutContext = ConsoleLayout.useLayoutContext()
  const state$ = useObservable({ isTooltipOpen: false })

  const handleTooltipOnOpenChange = useCallback((open: boolean) => {
    const isSidebarOpen = layoutContext.state$.isSidebarOpen.get()

    if (!isSidebarOpen) {
      state$.isTooltipOpen.set(open)
    }
  }, [])

  return (
    <ReactiveTooltip
      $open={() => layoutContext.state$.isSidebarOpen.get() ? false : state$.isTooltipOpen.get()}
      onOpenChange={handleTooltipOnOpenChange}
    >
      <TooltipTrigger asChild>
        <li className="mb-1 mt-5 w-full">
          <Reactive.div
            $className={
              () => cn('flex items-center px-5 h-[18px] gap-4 text-xs font-medium text-muted-foreground/70 cursor-text', {
                'cursor-pointer': !layoutContext.state$.isSidebarOpen.get(),
              })
            }
          >
            <Show
              if={layoutContext.state$.isSidebarOpen}
              wrap={AnimatePresence}
              else={
                (
                  <span>
                    <Icon
                      height="18"
                      icon="lucide:ellipsis"
                      width="18"
                    />
                  </span>
                )
              }
            >
              {
                () => (
                  <span className="capitalize">
                    {sectionLabel}
                  </span>
                )
              }
            </Show>

          </Reactive.div>

        </li>
      </TooltipTrigger>

      <TooltipContent
        side="right"
        sideOffset={15}
      >
        <span className="text-xs font-medium capitalize">
          {sectionLabel}
        </span>
      </TooltipContent>
    </ReactiveTooltip>
  )
}

MenuSection.displayName = 'ConsoleMenuSection'

export { MenuSection }
